module.exports = "https://static.wanderu.com/static/media/chiku-mobile.83ae0ac3.svg";